<script setup>

</script>
<template>
        <div class="animate-pulse w-full h-auto bg-slate-300 rounded-xl p-6 mt-5 space-y-10">
            <div class="">
                <div class="h-4 bg-slate-400/50 rounded-xl w-20"></div>
                <div class="grid grid-cols-2 gap-1 mt-3">
                    <div class="w-full h-8 bg-slate-400/50 rounded-tl-xl"></div>
                    <div class="w-full h-8 bg-slate-400/50 rounded-tr-xl"></div>
                </div>
                <div class="w-full h-8 bg-slate-400/50 rounded-b-xl mt-1"></div>
            </div>
    </div>
</template>